import { PropsWithChildren } from 'react';

export const CorporateLayout = ({ children }: PropsWithChildren<unknown>) => {
  return <>{children}</>;
};
